module.exports = __webpack_public_path__ + "images/accents/accent-product-suite@2x-9141df8feb6c45a3cae41fc2c52ed1fd.webp";